export default function(to, from, savedPosition) {
        if (process.client && savedPosition) {
          return new Promise((resolve) => {
            // delay (ms)
            console.log('savedPosition start', savedPosition);
            setTimeout(() => {
              console.log('savedPosition end', savedPosition);
              const pos = savedPosition ?
              {
                top: savedPosition.y || savedPosition.top || 0,
                left: savedPosition.x || savedPosition.left || 0
              } :
              { top: 0, left: 0 };

              window.scrollTo({ ...pos, behavior: 'smooth' });

              // Resolve to a matching position so router doesn't fight the manual scroll
              resolve({ x: pos.left || 0, y: pos.top || 0 });
            }, 500);
          });
        }

        // Fallback on server
        return savedPosition || { x: 0, y: 0 };
      }
